const DefaultData = {
  DEFAULTCURRENCY: "₦",  // Nigerian Naira
};

export default DefaultData;